module.exports = __webpack_public_path__ + "static/las_thumb-c7704427435004078636192be85b2cdb.jpg";